<section>
  <!-- Certification Acknowledgement Modal -->
  @if (showAcknowledgementModal && isTranslationLoaded) {
    <app-certification-acknowledgement-modal
      [moduleAssignmentUuid]="callStore.getModuleAssignmentUuid()"
      [isCameraInterruption]="isCameraInactiveInterruption"
      (acknowledged)="onAcknowledged($event)"
      (cancelled)="onAcknowledgementCancelled()">
    </app-certification-acknowledgement-modal>
  }

  <!-- Camera Inactive Warning Overlay -->
  <app-camera-inactive-warning
    [isVisible]="showCameraInactiveWarning">
  </app-camera-inactive-warning>

  <app-gender-selection-modal
    *ngIf="showGenderModal && isTranslationLoaded"
    (genderSaved)="closeModal()">
  </app-gender-selection-modal>

  <div *ngIf="!showGenderModal && isTranslationLoaded">
    <div
      class="loading"
      *ngIf="showLoadingScreen"
    >
      <p>{{'call.LOADING' | transloco}}</p>
      <app-three-dots-blinking></app-three-dots-blinking>
    </div>

    <ng-container *ngIf="!showPathwayScreen">
      <!-- coach view -->
      <app-pre-call
        *ngIf="(controlService.isCallTypeResolved$ | async) && showPreCallScreen"
        [playerService]="playerService"
        [controlService]="controlService"
      ></app-pre-call>

     <!-- device settings view -->
     <app-device-settings-call
     *ngIf="
       showDeviceSettingsScreen &&
       (controlService.isCallTypeResolved$ | async)
     "
     [deviceSettingsService]="deviceSettingsService"
     [controlService]="controlService"
     [playerService]="playerService"
   ></app-device-settings-call>

      <app-call-practice
        *ngIf="
          (controlService.isCallTypeResolved$ | async) &&
          showPracticeScreen
        "
        [playerService]="playerService"
        [controlService]="controlService"
        [userVideoService]="userVideoService"
        [deviceSettingsService]="deviceSettingsService"
        [realtimeService]="realtimeService"
      ></app-call-practice>

      <app-call-practice-visual-aid
        *ngIf="
          (controlService.isCallTypeResolved$ | async) &&
          showVisualAidScreen
        "
        [playerService]="playerService"
        [controlService]="controlService"
        [deviceSettingsService]="deviceSettingsService"
      ></app-call-practice-visual-aid>
    </ng-container>

    <!-- Pathway view -->

    
    <app-call-pathway
       *ngIf="showPathwayScreen"
      [controlService]="controlService"
      [realtimeService]="realtimeService"
      [userVideoService]="userVideoService"
      [deviceSettingsService]="deviceSettingsService"
      [playerService]="playerService"
      [callStore]="callStore"
      [enrollmentStepUuid]="enrollmentStepUuid"
      [enrollmentUuid]="enrollmentUuid"
      [stepType]="stepType"
    ></app-call-pathway>

    <!-- Roleplay Pathway view (PRACTICE / CERTIFICATION step types) -->
    <!-- <app-call-pathway-roleplay
      [controlService]="controlService"
      [realtimeService]="realtimeService"
      [userVideoService]="userVideoService"
      [deviceSettingsService]="deviceSettingsService"
      [playerService]="playerService"
      [callStore]="callStore"
      [enrollmentStepUuid]="enrollmentStepUuid"
      [enrollmentUuid]="enrollmentUuid"
      [stepType]="stepType"
    ></app-call-pathway-roleplay> -->
  </div>
</section>